import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import PhoneIcon from '@mui/icons-material/Phone';

import IconButton from '@mui/material/IconButton';
import style from './social.css'
const socials = [
    {
        id:1,
        name:'Github',
        icon:<GitHubIcon/>,
        link : 'https://github.com/Winlecodeur'

    },
    {
        'id':2,
        name:'Instagram',
        icon:<InstagramIcon/>,
         link : 'https://www.instagram.com/?igsh=dTkzanMxb2oybXp5'

    },
    {
        'id':3,
        name:'Phome number',
        icon:<PhoneIcon/>,
         link : ''

    },
    {
        'id':4,
        name:'Whatsapp',
        icon:<WhatsAppIcon/>,
         link : 'https://wa.me/3855989963'


    },
]

export const  Social = () => {
    return (
        <ul className="ul-img">
               {socials.map((social) => (
        <div key={social.id} style={style} className="div-img">
       <IconButton
            component="a"
            href={social.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.name}
          >
            {social.icon}
          </IconButton>
       
        </div>
      ))}
        </ul>
    )
};

